import { SystemLogGridView } from '~/components/system/system-log';
import { PageContainer } from '~/components/page-container';

export function SystemLog() {
	return (
		<PageContainer>
			<SystemLogGridView />
		</PageContainer>
	);
}
